module.exports = __webpack_public_path__ + "img/pencil-alt-5.0b8ec275.svg";